module.exports = require("./dist/slick.js");


//////////////////
// WEBPACK FOOTER
// angular-slick (bower component)
// module id = 1465
// module chunks = 0